import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import Reducers from './Reducers';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth'],
}

const persistedReducer = persistReducer(persistConfig, Reducers);

export default () => {
  let store = createStore(persistedReducer/*, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()*/, applyMiddleware(thunk));
  let persistor = persistStore(store);
  return { store, persistor }
}


// WEBPACK FOOTER //
// ./src/ConfigStore.js